
import Form from './form'
import Files from './files/index'

import ExtensionService from 'live/services/extension'
import { TYPE } from './interface/Config';

const sftp = {
    name: 'Upload SFTP',
    type: TYPE,
    origin: 'Plugin Upload SFTP',
    roles: [],
    icon: '/content/plugin-upload/UploadSftp.png',
    ui: {
        form: Form,
        view: null,
        custom: {
            'files': {
                label: 'Files',
                component: Files
            }
        }
    }
};

ExtensionService.register(sftp);
